// Utility function to open chat widget
// This function attempts to open Zendesk chat widget

export const openChat = () => {
  // Try Zendesk (primary method)
  if (window.zE) {
    try {
      // Try modern messenger API first
      window.zE("messenger", "open");
      console.log("Zendesk chat opened successfully");
      return;
    } catch (e) {
      console.log("Zendesk messenger API error, trying webWidget API");
      try {
        // Fallback to older webWidget API
        window.zE("webWidget", "open");
        console.log("Zendesk chat opened via webWidget API");
        return;
      } catch (err) {
        console.error("Zendesk webWidget API error:", err);
      }
    }
  }

  // Try Intercom (fallback)
  if (window.Intercom) {
    window.Intercom("show");
    console.log("Intercom chat opened");
    return;
  }

  // Try Crisp (fallback)
  if (window.$crisp) {
    window.$crisp.push(["do", "chat:open"]);
    console.log("Crisp chat opened");
    return;
  }

  // Try Tawk.to (fallback)
  if (window.Tawk_API) {
    window.Tawk_API.maximize();
    console.log("Tawk.to chat opened");
    return;
  }

  // Fallback - show contact info if no chat widget is detected
  console.warn("No chat widget detected. Showing contact information.");
  alert("Chat is loading... If it doesn\'t appear, please contact us at:\nPhone: +1 833 201 7583\nEmail: info@whitehousepublishers.com");
};
